/* Oxalis — the single wishlist system.
   Source of truth: localStorage key "oxalis:wishlist" = array of product handles.
   Powers every heart button on the site (product cards in the carousel, "Toutes
   nos créations", collections, search, recommendations, the product page) and
   the /pages/favoris listing. State stays consistent across navigation, reload
   and AJAX content swaps (a MutationObserver re-syncs new buttons). */
(function () {
  'use strict';
  if (window.OxalisWishlist) return; // guard against double init

  var KEY = 'oxalis:wishlist';
  var ACTIVE_LABEL = 'Retirer des favoris';
  var INACTIVE_LABEL = 'Ajouter aux favoris';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode / storage disabled — the in-page state below still works */
    }
    document.dispatchEvent(new CustomEvent('oxalis:wishlist:change', { detail: list.slice() }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    if (!handle) return false;
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    return list.indexOf(handle) !== -1;
  }

  function applyState(btn) {
    var handle = btn.getAttribute('data-product-handle');
    var active = has(handle);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? ACTIVE_LABEL : INACTIVE_LABEL);
  }

  var syncScheduled = false;
  function sync() {
    if (syncScheduled) return;
    syncScheduled = true;
    window.requestAnimationFrame(function () {
      syncScheduled = false;
      document.querySelectorAll('[data-wishlist-toggle]').forEach(applyState);
    });
  }

  /* ---- interaction (event delegation, works for AJAX-added buttons) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    var active = toggle(handle); // writes localStorage + fires oxalis:wishlist:change

    // first click = filled immediately, on EVERY heart of this same product
    if (handle) {
      document.querySelectorAll('[data-wishlist-toggle][data-product-handle="' + handle + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
        b.setAttribute('aria-label', active ? ACTIVE_LABEL : INACTIVE_LABEL);
      });
    }
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    btn.classList.add('is-pop');
  });

  document.addEventListener('oxalis:wishlist:change', sync);
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) sync();
  });
  window.addEventListener('pageshow', sync); // bfcache restore

  /* ---- keep new (AJAX-rendered) cards in sync ---- */
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var n = records[i].addedNodes[j];
          if (n.nodeType === 1 &&
              (n.matches && n.matches('[data-wishlist-toggle]') ||
               n.querySelector && n.querySelector('[data-wishlist-toggle]'))) {
            sync();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  window.OxalisWishlist = { read: read, has: has, toggle: toggle, sync: sync, KEY: KEY };
  sync();

  /* ---------------- /pages/favoris listing ---------------- */
  var mount = document.querySelector('[data-wishlist-list]');
  if (!mount) return;

  var emptyEl = document.querySelector('[data-wishlist-empty]');
  var money = function (cents) {
    return (cents / 100).toLocaleString('fr-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };
  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var toggleEmpty = function () {
    var hasCards = !!mount.querySelector('[data-wishlist-card]');
    if (emptyEl) emptyEl.hidden = hasCards;
    mount.hidden = !hasCards;
  };

  function heartSvg() {
    /* fill:none — the filled state comes from the global CSS rule on
       [data-wishlist-toggle][aria-pressed='true'] svg path, like every other heart */
    return '<svg class="icon icon--heart" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" d="M12 20.5c-4.7-3-9-6.4-9-11A5 5 0 0 1 12 6a5 5 0 0 1 9 3.5c0 4.6-4.3 8-9 11z"/></svg>';
  }

  function render() {
    var handles = read();
    if (!handles.length) { mount.innerHTML = ''; toggleEmpty(); return; }
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      mount.innerHTML = '';
      var frag = document.createDocumentFragment();
      products.filter(Boolean).forEach(function (p) {
        var img = p.featured_image || (p.media && p.media[0] && p.media[0].src) || '';
        var price = money(p.price);
        if (p.compare_at_price && p.compare_at_price > p.price) {
          price = '<span class="product-card__price-sale">' + money(p.price) + '</span> <s class="product-card__price-was">' + money(p.compare_at_price) + '</s>';
        }
        var el = document.createElement('div');
        el.className = 'product-card';
        el.setAttribute('data-wishlist-card', '');
        el.setAttribute('data-handle', p.handle);
        el.innerHTML =
          '<a class="product-card__media product-card__media--portrait" href="' + p.url + '">' +
          (img ? '<img class="product-card__img" src="' + img + '&width=600" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="product-card__fav" data-wishlist-toggle data-product-handle="' + p.handle + '" aria-pressed="true" aria-label="' + ACTIVE_LABEL + '">' + heartSvg() + '</button>' +
          '<div class="product-card__info"><h3 class="product-card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h3><p class="product-card__price">' + price + '</p></div>';
        frag.appendChild(el);
      });
      mount.appendChild(frag);
      toggleEmpty();
      sync();
    });
  }

  document.addEventListener('oxalis:wishlist:change', function () {
    var handles = read();
    mount.querySelectorAll('[data-wishlist-card]').forEach(function (card) {
      if (handles.indexOf(card.getAttribute('data-handle')) === -1) {
        card.style.transition = 'opacity .2s ease';
        card.style.opacity = '0';
        window.setTimeout(function () { card.remove(); toggleEmpty(); }, 200);
      }
    });
  });

  render();
})();
